import React from "react";
import { useParams } from "react-router-dom";
import { useResource } from "hooks";
import { Form, Col, message } from "antd";
import { LoadingSpinner } from "components/v2/Loading/LoadingSpinner/LoadingSpinner";
import { Formik, Field } from "formik";
import { Elements, Fragments, Fields } from "components";
import { Link } from "react-router-dom";
import { schemas, utils } from "common";
import { useAPIContext } from "components/providers/Api";
import styles from "./upsells.module.css";

const {
  Titles: { BlueCardTitle, SectionTitle },
  Row,
  Button,
  T,
} = Elements;
const { mapAxiosError } = utils;
const {
  Cards: { BlueCard },
  Tables: { LocationToggleTable },
  EntityToggle,
  ConfirmationButton,
} = Fragments;
const { UpsellSchema } = schemas;

const Upsell = ({ locations }) => {
  const { Upsells } = useAPIContext();
  const { upsellId } = useParams();

  const {
    resource: upsell,
    fetching,
    fetch,
  } = useResource({
    path: `/upsells/${upsellId}`,
  });
  const {
    priority,
    disabledLocations,
    excludedLocations,
    item = {},
    group = {},
  } = upsell;

  const save = async (data) => {
    try {
      await Upsells.update(upsellId, data);
      message.success("Succesfully Saved");
    } catch (err) {
      message.error(mapAxiosError(err));
    }
  };
  const deleteUpsell = async () => {
    try {
      await Upsells.delete(upsellId);
      message.success("Succesfully Saved");
      fetch();
    } catch (err) {
      message.error(mapAxiosError(err));
    }
  };

  if (fetching) return <LoadingSpinner />;
  return (
    <Formik
      initialValues={{
        priority,
        excludedLocations,
        disabledLocations,
      }}
      validateOnChange={false}
      validationSchema={UpsellSchema}
      enableReinitialize
      onSubmit={async (formValues, actions) => {
        const data = { ...formValues };
        data.disabledLocations = formValues.disabledLocations.map((loc) => {
          if (typeof loc === "object") return loc.id;
          return loc;
        });
        await save(data);
        actions.setSubmitting(false);
      }}
      render={({ handleSubmit, isSubmitting, values, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <BlueCard>
            <Row>
              <Col xs={15}>
                <BlueCardTitle>{`${item.name} Upsell`}</BlueCardTitle>
              </Col>
              <Col xs={9} className={styles.entityToggle}>
                <EntityToggle
                  checked={upsell.isActive}
                  path={`/upsells/${upsellId}`}
                />
              </Col>
            </Row>
            <Row spacing={10}>
              <Col>
                <T label inline>
                  {`Item: `}
                </T>
                <T copyable={{ text: item.externalId }} inline>
                  <Link to={`/item/${item?.id}`}>{item.externalId}</Link>
                </T>
              </Col>
              <Col>
                <T label inline>
                  {`Group: `}
                </T>
                <T copyable={{ text: group.externalId }} inline>
                  <Link to={`/group/${group?.id}`}>{group.externalId}</Link>
                </T>
              </Col>
            </Row>
            <Col xs={24} sm={12}>
              <div className={styles.detailsContainer}>
                <SectionTitle>Edit Details</SectionTitle>

                <Row spacing={230}>
                  <Field
                    name="priority"
                    label="Priority"
                    placeholder="0"
                    size="small"
                    type="number"
                    component={Fields.Input}
                  />
                </Row>

                <Col xs={12} className={styles.saveButton}>
                  <Button
                    width="90%"
                    htmlType="submit"
                    size="small"
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    color="blue"
                  >
                    Save
                  </Button>
                </Col>
                <Col xs={12} className={styles.rightAlign}>
                  <ConfirmationButton
                    placement="bottom"
                    title="Are you sure you want to delete this upsell"
                    okText="Yes"
                    onConfirm={deleteUpsell}
                  >
                    <Button
                      size="small"
                      color="red"
                      disabled={upsell.isDeleted}
                    >
                      {upsell.isDeleted ? "Deleted" : "Delete"}
                    </Button>
                  </ConfirmationButton>
                </Col>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <LocationToggleTable
                height={300}
                onSelection={save}
                excludedLocations={excludedLocations}
                disabledLocations={values.disabledLocations}
                locations={locations}
                setFieldValue={setFieldValue}
                loading={fetching || isSubmitting}
              />
            </Col>
          </BlueCard>
        </Form>
      )}
    />
  );
};

export default Upsell;
